import request from '@/utils/request'

export function monitor() {
  return request({
    url: '/monitor',
    method: 'get'
  })
}
